import { Injectable } from '@angular/core';
import { MenuEntry } from './entry.schema';
import { Menu } from './menu';

/**
 * @description
 * A service manage menu items
 */
@Injectable()
export class SideMenuService {
  private readonly menus: Map<string, Menu> = new Map();

  constructor() {}

  /**
   * Returns the specified menu from the list of existing menu.
   * If the name provided doesn't match any of the items in the map, its instance will be created and returned.
   * @param {string} name of the menu to read from
   */
  get(name: string = 'main'): Menu {
    let menu = this.menus.get(name);
    if (!menu) {
      menu = new Menu();
      this.menus.set(name, menu);
    }
    return menu;
  }

  /**
   * Add a menu to the system
   * @param {MenuEntry} menuEntry
   * @param {string} name name of the menu in which add the element
   */
  addMenuEntry(menuEntry: MenuEntry, name: string = 'main') {
    const menu: Menu = (this.menus.has(name) && this.menus.get(name)) || this.menus.set(name, new Menu()).get(name);

    menu.addItem(menuEntry);
  }

  /**
   * Remove an entry from the menu
   * @param {MenuEntry} menuEntry
   * @param {string} name of the menu in which removing element
   */
  removeMenuEntry(menuEntry: MenuEntry, name: string = 'main'): void {
    const menu: Menu = (this.menus.has(name) && this.menus.get(name)) || this.menus.set(name, new Menu()).get(name);

    menu.removeItem(menuEntry);
  }
}
